import { compose, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import routes from '../routes';

const fallbackStyles = {
  background: {
    backgroundColor: '#1B1B1B'
  },
  header: {
    logo: {
      fill: '#fff'
    },
    text: {
      color: 'rgba(0,0,0,0)'
    },
    button: {
      color: '#fff',
      borderColor: '#fff',
      backgroundColor: 'rgba(0,0,0,0)'
    },
    buttonHover: {
      color: '#1B1B1B',
      borderColor: '#fff',
      backgroundColor: '#fff'
    }
  },
  footer: {
    color: '#fff'
  },
  scroller: {
    color: 'rgba(0,0,0,0)'
  },
  landscapeOverlay: {
    logo: {
      fill: '#fff'
    },
    text: {
      color: '#fff'
    }
  }
};

const getRouteComponentStyles = (path, component) =>
  get(
    routes.find(route => route.path === path),
    `styles.${component}`,
    fallbackStyles[component]
  );

export default path =>
  compose(
    withRouter,
    withState('style', 'setStyle', ({ location }) =>
      getRouteComponentStyles(location.pathname, path)
    ),
    lifecycle({
      componentDidUpdate(prevProps) {
        const currentPathname = this.props.location.pathname;

        if (currentPathname !== prevProps.location.pathname) {
          this.props.setStyle(getRouteComponentStyles(currentPathname, path));
        }
      }
    })
  );
